import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
    breadcrumbs: {
        marginBottom: theme.spacing(1),
    },
    heading: {
        marginBottom: theme.spacing(2),
    },
}));
